<template>

    <section class="faq">
        <div class="container">
            <div class="text-center">
                <h2 class="fw-bold section-title">{{ $t("frequently_asked_questions") }} </h2>
            </div>
            <!-- <Card :items="services" className="mt-4 mt-lg-0" /> -->
            <BRow>
                <BCol cols="12" md="6" class="image-wrapper d-none d-md-block">
                    <img src="@/esf_venlo_base/assets/images/faq.png" class="faq-image" alt="faq image">
                </BCol>
                <BCol cols="12" md="6">
                    <BAccordion v-if="faqs.length > 0">
                        <template v-for="(faq, index) in faqs.find(item => item.title === 'faq-page')?.faq.items">
                            <BAccordionItem :title="faq.question" :visible="index === 0">
                                {{ faq.short_answer }}
                            </BAccordionItem>
                        </template>
                    </BAccordion>
                </BCol>
            </BRow>
        </div>
    </section>

</template>


<script setup>
import { useStore } from "vuex";
import { computed } from "vue";

const store = useStore();
const faqs = computed(() => store.getters["faq/getFaq"]);
</script>
